import IconifyIcon from '../IconifyIcon';
import { useNavigate } from 'react-router-dom';

const ActivityStreamToggle = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/admin/orders');
  };

  return (
    <div className="topbar-item d-none d-md-flex">
      <button
        onClick={handleClick}
        type="button"
        className="topbar-button"
        id="theme-activity-btn"
        title="Orders"
      >
        <IconifyIcon icon="solar:clock-circle-bold-duotone" style={{ fontSize: '22px' }} />
      </button>
    </div>
  );
};

export default ActivityStreamToggle;
